export type Currency = {
  id?: string
  address?: string
  decimals: number
  name: string
  symbol: string
}
